module.exports = __webpack_public_path__ + "img/202601_06.d11625e2.png";